export * from './allocation-view-call-to-waiting-area-action.state';
export * from './allocation-view-call-to-waiting-area-action.facade';
